import { HttpInterceptorFn } from "@angular/common/http";

export const timezoneInterceptor: HttpInterceptorFn = (request, next) => {
    return next(
        request.clone({
            headers: request.headers.set("timezone", Intl.DateTimeFormat().resolvedOptions().timeZone)
        })
    );
};
